import EmailIcon from './components/EmailIcon';
import counterAppImage from './assets/images/counterAppImage.png';
import emotionLogImage from './assets/images/emotionLog.png';
import './styles/App.css';

interface AppData {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  link: string;
}

const apps: AppData[] = [
  {
    id: 1,
    name: "ベーシックカウンター",
    description: "シンプルなカウンター機能を提供するアプリです。",
    imageUrl: counterAppImage,
    link: "https://basic-counter-prod.web.app/app_introduction"
  },
  {
    id: 2,
    name: "EmotionLog",
    description: "日々の感情を手軽に記録し、カレンダーやグラフで手軽に振り返るアプリです。",
    imageUrl: emotionLogImage,
    link: "https://emotion-log-895eb.web.app/app_introduction"
  }
  /*
  {
    id: 2,
    name: "アプリ名2",
    description: "革新的な機能を備えたアプリです。使いやすさを重視して開発しました。",
    imageUrl: "/app-placeholder.png",
    link: "#"
  },
  {
    id: 3,
    name: "アプリ名3",
    description: "日常生活をより便利にするアプリです。シンプルで使いやすい設計です。",
    imageUrl: "/app-placeholder.png",
    link: "#"
  }
  */
];

function App() {
  return (
    <div className="app">
      <div className="container">
        <h1 className="title">TETORA DEVELOPER</h1>

        {apps.length > 0 && (
          <div className="apps-grid">
            {apps.map(app => (
              <div key={app.id} className="app-card">
                <div className="app-image">
                  <img src={app.imageUrl} alt={app.name} />
                </div>
                <h3 className="app-title">{app.name}</h3>
                <p className="app-description">{app.description}</p>
                <a href={app.link} className="app-link">詳細を見る</a>
              </div>
            ))}
          </div>
        )}

        <div className="social-links">
          <a href="mailto:developer.poteto.contact@gmail.com">
            <EmailIcon />
          </a>
        </div>

        <p className="copyright">© 2025 Tetora Developer. All Rights Reserved.</p>
      </div>
    </div>
  );
}

export default App;
